import React from 'react';
import { HitScopeClip, HitScopeClipListProps } from '../hitScope.types';
import { Box, Spinner, Text } from 'grommet';
import HitscopeDataTable from '../components/HitScopeDataTable';

const ClipEmptyState = () => (
  <Box data-testid="hitscope-no-clips">
    No clips in the selected time period
  </Box>
);

const HitScopeClipList: React.FC<HitScopeClipListProps> = ({
  clips,
  selectedClip,
  setManualSelectedClip,
  track,
  loading,
}) => {
  return (
    <Box gap="small">
      <Text>Jump to any AB by clicking on it.</Text>
      {loading && (
        <Box gap="small">
          <Spinner
            size="medium"
            message="Start Built-in Spinner Announcement"
          />
          <Text data-testid="hitscope-loading">
            Loading all HitScope clips... Hang tight! this can take up to 15
            seconds.
          </Text>
        </Box>
      )}
      {clips.length > 0 && selectedClip ? (
        <HitscopeDataTable
          playerId={track.playerId}
          data={clips}
          selectedClipId={selectedClip.id}
          track={track}
          onSelected={(clip: HitScopeClip) => {
            setManualSelectedClip(clip);
          }}
        />
      ) : (
        <ClipEmptyState />
      )}
    </Box>
  );
};

export default HitScopeClipList;
